module.exports = __webpack_public_path__ + "static/img/2.c849e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail0/2.png
// module id = okEt
// module chunks = 19